<template>
  <div
    v-if="testimonial"
    class="sm:justify-start my-12 md:my-20 max-w-expanded-md relative flex flex-row justify-end mx-auto"
  >
    <div class="sm:relative md:px-0 sm:pb-12 sm:w-3/5 md:w-[56%] absolute inset-x-0 top-0 w-full p-8">
      <FixedAspect :ratio="1" class="">
        <CldnImg
          v-if="testimonial.authorImage"
          :src="testimonial.authorImage[0].url"
          :alt="testimonial.authorImage[0].title"
          sizes="100vw sm:100vw md:360px lg:486px xl:486px 2xl:486px"
          crop="fill"
        />
      </FixedAspect>
    </div>
    <div
      class="sm:absolute sm:bottom-0 sm:right-0 sm:mr-8 mt-[80%] w-4/5 sm:mt-[20%] sm:w-[45%] sm:min-h-[70%] z-10 flex flex-col justify-between box"
    >
      <div class="text-copy mb-8 fluid-base leading-normal font-medium" v-html="testimonial.body"></div>
      <div class="text-br-green mt-auto fluid-xs leading-tightest">{{ testimonial.authorName }}</div>
    </div>
  </div>
</template>

<script setup>
import FixedAspect from '@/components/common/FixedAspect';
import CldnImg from '@/components/CldnImg';

const props = defineProps({
  testimonials: {
    type: Array,
    default: () => [],
  },
});

const testimonial = computed(() => {
  return props.testimonials && props.testimonials[0] ? props.testimonials[0] : null;
});
</script>
